import * as Yup from 'yup';

export default Yup.object().shape({
  token: Yup.string()
    .min(5, 'Muito curto')
    .max(10, 'Muito longo')
    .required('Campo obrigatório'),
});
